import { ssoLoginAPI } from '../services/SigninService';

export const ssoLoginAction = (data) => {
	return () => {
		return ssoLoginAPI(data);
	};
};
